import { render, staticRenderFns } from "./BaseFooterTitle.vue?vue&type=template&id=85801a06&scoped=true&"
import script from "./BaseFooterTitle.vue?vue&type=script&lang=js&"
export * from "./BaseFooterTitle.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooterTitle.vue?vue&type=style&index=0&id=85801a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_e0fc12eb4d0f55f4cb07c19882e21395/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85801a06",
  null
  
)

export default component.exports